export const collectScheduledContentIDs = (record = {}) => {
  const ids = [];
  const seen = new Set();

  const addValue = (value) => {
    if (value == null || value === false) return;
    if (Array.isArray(value)) {
      value.forEach(addValue);
      return;
    }
    const contentID = String(value).trim();
    if (!contentID || seen.has(contentID)) return;
    seen.add(contentID);
    ids.push(contentID);
  };

  addValue(record.contentIDs);
  addValue(record.contentID);

  return ids;
};

export const mergePublishedIntoGalleryItems = (
  items = [],
  refreshedItems = []
) => {
  if (!Array.isArray(items) || items.length === 0) return items;
  if (!Array.isArray(refreshedItems) || refreshedItems.length === 0) {
    return items;
  }

  const refreshedById = new Map(
    refreshedItems
      .filter((entry) => entry?.id != null)
      .map((entry) => [String(entry.id), entry])
  );

  if (refreshedById.size === 0) return items;

  return items.map((item) => {
    const refreshed = refreshedById.get(String(item?.id));
    if (!refreshed) return item;
    if (item.publishedSources === refreshed.publishedSources) return item;
    return {
      ...item,
      publishedSources: refreshed.publishedSources ?? null,
    };
  });
};
